import cn from 'classnames';
import React, { ReactNode } from 'react';
import { useCallback, useState } from 'react';
import Slider from 'react-slick';

import { ReactComponent as ArrowLeft } from '../../_icons/arrow-left-white.svg';
import { SliderArrow } from '../details-car/slider-arrow/slider-arrow';

import styles from './slider.module.scss';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

export const SliderSlick: React.FC<{
  sliderLength: number;
  children: ReactNode;
  slidesToShow?: number;
  slidesToScroll?: number;
  hasNav?: boolean;
  setSliderDom?: (slider: Slider) => void;
  id?: string;
  className?: string;
  pagination?: boolean;
  responsive?: any;
  centerMode?: boolean;
  isInfinite?: boolean;
  variableWidth?: boolean;
}> = ({
  sliderLength,
  children,
  slidesToShow = 3,
  slidesToScroll = 1,
  hasNav = false,
  setSliderDom = () => {
    return;
  },
  className,
  pagination = false,
  id,
  responsive,
  centerMode = false,
  isInfinite = false,
  variableWidth = false,
}) => {
  const [slider, setSlider] = useState<Slider>();
  const [prevDisabled, setPrevDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(false);

  const setSliderRef = useCallback(
    (slider: Slider) => {
      setSlider(slider);
      setSliderDom(slider);
    },
    [setSlider, setSliderDom],
  );

  const handleNext = () => {
    if (nextDisabled) return;

    slider?.slickNext();
  };

  const handlePrev = () => {
    slider?.slickPrev();
  };

  const handleAfterChange = (index: number) => {
    setPrevDisabled(index === 0);
    setNextDisabled(index === sliderLength - slidesToShow);
  };

  return (
    <div className={cn(styles.sliderWrapper, className)} id={id}>
      <Slider
        arrows={false}
        className={styles.slider}
        dots={pagination}
        accessibility
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToScroll}
        ref={setSliderRef}
        responsive={responsive}
        afterChange={handleAfterChange}
        infinite={isInfinite}
        centerMode={centerMode}
        variableWidth={variableWidth}
      >
        {children}
      </Slider>
      {hasNav ? (
        <div className={styles.sliderArrows}>
          <SliderArrow
            onClick={handlePrev}
            icon={<ArrowLeft />}
            className={cn(styles.sliderArrow, styles.sliderArrowPrev, {
              [styles.sliderArrowDisabled as string]: prevDisabled,
            })}
          />
          <SliderArrow
            onClick={handleNext}
            icon={<ArrowLeft className={styles.arrowRight} />}
            className={cn(styles.sliderArrow, {
              [styles.sliderArrowDisabled as string]: nextDisabled,
            })}
          />
        </div>
      ) : null}
    </div>
  );
};
